import { useState, useEffect } from 'react';
import { ScreenerIcon } from '../components/Icons';
import { fetchScreener, detectCurrency } from '../utils/api';

function StockScreener() {
  const [stocks, setStocks] = useState([]);
  const [sector, setSector] = useState('All');
  const [market, setMarket] = useState('All');
  const [live, setLive] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => { loadStocks(false); }, [sector, market]);

  async function loadStocks(fetchLive) {
    setLoading(fetchLive);
    const data = await fetchScreener(sector, market, fetchLive);
    setStocks(data);
    if (fetchLive) setLive(true);
    setLoading(false);
  }

  return (
    <div>
      <div className="page-title">
        <ScreenerIcon size={28} color="#00ff9d" />
        <h1>Stock Screener</h1>
      </div>
      <p className="hero-subtitle">Browse popular NASDAQ and TSX stocks filtered by sector</p>

      <div className="form-row" style={{ marginBottom: 16 }}>
        <div className="form-group">
          <label className="form-label">Filter by Sector</label>
          <select className="input-field" value={sector} onChange={e => { setSector(e.target.value); setLive(false); }}>
            {['All', 'Technology', 'Financials', 'Consumer', 'Energy'].map(s => (
              <option key={s} value={s}>{s}</option>
            ))}
          </select>
        </div>
        <div className="form-group">
          <label className="form-label">Filter by Market</label>
          <select className="input-field" value={market} onChange={e => { setMarket(e.target.value); setLive(false); }}>
            {['All', 'NASDAQ', 'TSX'].map(m => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '8px 0 16px' }}>
        <span style={{ color: '#64748b', fontSize: '0.9rem' }}>
          Showing <strong style={{ color: '#cbd5e1' }}>{stocks.length}</strong> stocks
        </span>
        <span className="live-badge">LIVE PRICES</span>
      </div>

      <button className="btn-primary" onClick={() => loadStocks(true)} disabled={loading} style={{ marginBottom: 16 }}>
        {loading ? <><span className="spinner" />Fetching...</> : 'Fetch Live Prices'}
      </button>

      <div className="glass-card" style={{ padding: 0, overflow: 'auto' }}>
        <table className="data-table">
          <thead>
            <tr>
              <th>Ticker</th>
              <th>Company</th>
              <th>Sector</th>
              <th>Market</th>
              <th>Price</th>
              <th>Currency</th>
              <th>Change %</th>
            </tr>
          </thead>
          <tbody>
            {stocks.map(s => (
              <tr key={s.ticker}>
                <td style={{ color: '#e2e8f0', fontWeight: 600 }}>{s.ticker}</td>
                <td>{s.company}</td>
                <td>{s.sector}</td>
                <td>{s.market}</td>
                <td>{s.price !== undefined ? s.price.toFixed(2) : '—'}</td>
                <td>{s.currency || detectCurrency(s.ticker)}</td>
                <td className={s.change_pct !== undefined ? (s.change_pct >= 0 ? 'gain' : 'loss') : ''}>
                  {s.change_pct !== undefined ? `${s.change_pct >= 0 ? '+' : ''}${s.change_pct.toFixed(2)}%` : '—'}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {!live && <p style={{ color: '#475569', fontSize: '0.85rem', marginTop: 8 }}>Click <strong>Fetch Live Prices</strong> to load current market data.</p>}
    </div>
  );
}

export default StockScreener;
